export default "__VITE_ASSET__aa27d909__"